import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import useCookie from "../hooks/useCookie";
import useAuth from '../hooks/useAuth';
import '../css/pages/login_page.css';
import '../css/loading_animation.css';

const LoginForm = () => {
  
  const [t] = useTranslation('global');
  const { setAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [formData, setFormData] = useState({ username: '', password: '' });  
  const [ulaCookie,setCookie] = useCookie("ULA");
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/"; 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const setLanguageCookie = () => {
    if (ulaCookie) {
      return;
    } else {
      let lang = JSON.stringify("en");
      setCookie("ULA", lang, { maxAge: 86400 }); 
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let payload = {
      UserEmail: formData.username,
      Password: formData.password,
    };  
    
   await axios.post("/api/auth/Authenticate", payload, { withCredentials : true })
    .then(response => {
      axios.post("/api/auth/GetUserByCookie", { }, { withCredentials: true })  
      .then(r => {   
          const uid = r.data.id;
          const ufn = r.data.userFirstname;
          const uln = r.data.userLastname;
          const uem = r.data.userEmail;
          const uia = r.data.isActive;
          const uri = r.data.roleId;
          
          setAuth({uid, ufn, uln, uem, uia, uri});
          setLanguageCookie();
          navigate(from);
      }).catch(tokenErr => {
        setErrorMessage('Token error');
        setIsLoading(false);
      })
    }).catch(authErr => {
      setErrorMessage('Incorrect username or password');    
      setIsLoading(false);
    })
  };

  return (
    <div className='login-page'>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="milladaTitle">
          Mi<span className="stripe-1">l</span>
          <span className="stripe-2">l</span>ada
        </div>
        <div className="milladaSubtitle">{t('login')}</div>
        <div className="login-inputs">
          <div>
            <input
              type="text"
              id="username"
              name="username"
              placeholder={t('email')}
              value={formData.username}
              onChange={handleChange}
            />
          </div>
          <div>
            <input
              type="password"
              id="password"
              name="password"
              placeholder={t('password')}
              value={formData.password}
              onChange={handleChange}
            />
          </div>
          <button 
              type="submit"
              id="logIn"
              disabled={isLoading}>
              {t('loginNow')}
           </button>
        </div>
        {isLoading ? <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div> : ''}
        {errorMessage ? <div className="login-message">{errorMessage}</div> : ''}
      </form>
    </div>
  );
};

export default LoginForm;
